var self = module.exports;

// define default regex
var __globals = {
    lowercase: /[a-z]/,
    uppercase: /[A-Z]/,
    number: /[0-9]/,
    specialChar: /[^\w\s]+/
}

/**
 * Validates a custom provided password.
 * @type {Function}
 */
self.validate = ((password, options, minimumLength) => {

    try {
        // check for password
        if (!password || typeof password === 'object')
            throw "Invalid input value for handle validation!"

        // Set defaults.
        options = options || {};

        // get length of this object and set for future processment
        let objLength = Object.keys(options).length

        // validate regex
        let results = []
        let index = 0
        for (let key in options) {
            if (options[key] && typeof options[key] === 'boolean') {
                results['has_' + key] = self.__checkCharType(password, key)
                if (results['has_' + key])
                    index++
            }
            // TODO - exclude some strings
        }

        // validate minimum length
        let minOption = self.__checkMinimumChar(password, minimumLength)
        results['has_minimum_length'] = minOption

        // check if this this string is validated
        if (objLength == index) {
            if (minOption) {
                results = {}
                results['isValidated'] = true
                return results
            }
        }

        return results;

    }catch (error) {
        console.log(error)
        return false
    }
});

/**
 * Check for custom char type regex
 * @type {Function}
 */
self.__checkCharType = ((val, type) => {
    const regex = new RegExp(__globals[type])
    if (regex.test(val))
        return true
    return false
});

/**
 * Check for string minimum length
 * @type {Function}
 */
self.__checkMinimumChar = ((val, length) => {
    if (val.length >= length)
        return true
    return false
});

self.__excludeChars = ((char, type) => {
    const regex = new RegExp(__globals[type])
    if (regex.test(val))
        return true
    return false
});

/**
 * Validates multiple passwords / text at once with the same options.
 * @type {function(*=, *=): Array}
 */
self.validateAll = ((multiplePasswords, options, minimumLength) => {
    var validations = [];

    if (typeof multiplePasswords === 'Array')
        multiplePasswords.forEach((el) => {
            validations[el] = self.validate(el, options);
        })

    return validations;
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/password-validator-minimalist/src/validate.js
// module id = MkB4
// module chunks = 0